import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Access",
  "lead": "على الصعيد العالمي، يكمل 88% من الأطفال تعليمهم الابتدائي، و78% من المراهقين يكملون تعليمهم الإعدادي و59% من الشباب يكملون تعليمهم الثانوي ا."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, Highlight, HighlightByIndex, IndicatorReference, PageLink, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky, Tooltip} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!Highlight) _missingMdxReference("Highlight", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!PageLink) _missingMdxReference("PageLink", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!Tooltip) _missingMdxReference("Tooltip", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_ACCESS"
    }), "\n", _jsx(_components.p, {
      children: "لم يفِ العالم بوعده في ضمان التحاق جميع الأطفال بالتعليم الابتدائي بحلول عام 2015. لقد حدد الهدف التعليمي الجديد، الهدف الرابع من أهداف التنمية المستدامة، مستوى طموح أعلى، داعياً إلى إكمال جميع الشباب التعليم الثانوي بحلول الموعد النهائي لعام 2030.. ولتحقيق هذه الغاية، كان من المفترض أن يبدأ جميع الأطفال في سن الالتحاق بالمدرسة  الدراسة في عام 2018، ولكن  في  الواقع، لم يلتحق سوى 70% منهم في البلدان منخفضة الدخل  على سبيل المثال."
    }), "\n", _jsx(_components.h2, {
      id: "المرحلة-التمهيدية-السابقة-للمدرسة",
      children: "المرحلة التمهيدية السابقة للمدرسة"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.2.2",
      children: _jsx(_components.p, {
        children: "**تعتبر المرحلة التمهيدية السابقة للمدرسة ** نقطة انطلاق حاسمة لرحلة الأطفال عبر التعليم. ومع ذلك، في البلدان المنخفضة الدخل، لا يلتحق سوى 44% من الأطفال  في هذه المرحلة التمهيدية  في العام السابق  للمدرسة الابتدائية."
      })
    }), "\n", _jsx(_components.p, {
      children: "منذ عام 2000، كان الانتظام في التعليم ما قبل المدرسة يسير بخطى وئيدة لكن ثابتة في معظم البلدان، بما في ذلك في العديد من البلدان الأشد فقرًا، ولكن العديد من البلدان لا تزال متخلفة عن الركب. وعلى مستوى العالم، ينتظم 75% من الأطفال الآن في التعليم ما قبل الابتدائي مقارنةً بنسبة 64% في عام 2003."
    }), "\n", _jsx(_components.p, {
      children: "لقد شهدت بعض البلدان زيادات هائلة. وفي قيرغيزستان، على سبيل المثال، ارتفع معدل المشاركة من 42% في عام 2000 إلى 87% في عام 2024. وفي جمهورية لاو الديمقراطية الشعبية، ارتفعت النسبة من 10% إلى 89% خلال الفترة نفسها."
    }), "\n", _jsxs(_components.p, {
      children: ["إن كلًا من ", _jsx(HighlightByIndex, {
        index: "0",
        children: "غواتيمالا"
      }), " ", _jsx(HighlightByIndex, {
        index: "1",
        children: "والنيجر"
      }), " الموضحتين أدناه هما مثالان لبلدان شهدت زيادة مطردة في المداومة في مرحلة ما قبل التعليم الابتدائي، على الرغم من وجود فجوات هائلة بين البلدين اليوم. اختر بلدك لرؤية مدى التقدم الذي أحرزته."]
    }), "\n", _jsx(Figure, {
      id: "PREPRIM"
    }), "\n", _jsx(_components.h2, {
      id: "مشاركة-من-هم-أكبر-من-سن-الدراسة",
      children: "مشاركة من هم أكبر من سن الدراسة"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.5",
      children: _jsx(_components.p, {
        children: "نحن لا نتحدث بما فيه الكفاية عن حقيقة  العديد من  البلدان، حيث يُسجَّل أكثر من ربع طلاب في المرحلة  الابتدائية وهم متجاوزون لسنهم الدراسي، مما يعني أنهم أكبر سنًا مما هو مفترض لمستواهم الدراسي . وهذا من شأنه ترك آثار لا يستهان بها على مستقبلهم؛ إذ يزيد من احتمال تكرار الفصول الدراسية والرسوب في الامتحانات وفي النهاية التسرب من التعليم."
      })
    }), "\n", _jsxs(_components.p, {
      children: ["ينظر هذا الرسم البياني إلى ", _jsx(_components.strong, {
        children: "المشاركة في التعليم"
      }), "، موضحًا مدى تقدم الأطفال والمراهقين والشباب في العمر عندما يلتحقون بمرحلة ما قبل التعليم الابتدائي، والتعليم الابتدائي، والتعليم الإعدادي والثانوي، وكذلك مرحلة ما بعد التعليم الثانوي. يشير انتشار اللون إلى عدد الأطفال الذين تجاوزوا السن المناسب لمستواهم التعليمي. تبين المنطقة المظللة باللون الرمادي النسبة المئوية للأطفال والمراهقين الذين انقطعوا عن الدراسة حسب العمر."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "OVERAGE"
        })
      }), _jsx(ScrollySection, {
        id: "KHM",
        children: _jsxs(_components.p, {
          children: ["في ", _jsx(Highlight, {
            children: "كمبوديا"
          }), "، يجب أن يكون معظم الأطفال في المدرسة في سن العاشرة\nومع ذلك، فإن 21% منهم لا يزالون خارج الدراسة في هذا العمر. وكثير منهم أكبر سنًا\nمن الالتحاق بصفوفهم. هناك أطفال يبلغون من العمر 14 عامًا وما زالوا يذهبون إلى المدرسة الابتدائية،\nعلى سبيل المثال."]
        })
      }), _jsx(ScrollySection, {
        id: "LBR",
        children: _jsxs(_components.p, {
          children: ["يرتفع معدل تجاوز السن في بلدان مثل", " ", "\n", _jsx(Highlight, {
            children: "ليبيريا"
          }), "؛ حيث تبلغ نسبة الأطفال الذين تبلغ أعمارهم 10 أعوام في مرحلة ما قبل المدرسة 28%\nو20% من الأطفال الذين تبلغ أعمارهم 18 عامًا ما زالوا في المدرسة الابتدائية."]
        })
      }), _jsx(ScrollySection, {
        id: "NPL",
        children: _jsxs(_components.p, {
          children: [_jsx(Highlight, {
            children: "نيبال"
          }), " تواجه نفس التحدي"]
        })
      }), _jsx(ScrollySection, {
        id: "MWI",
        children: _jsxs(_components.p, {
          children: ["كما هو الحال مع ", _jsx(Highlight, {
            children: "مالاوي"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "الأطفال-غير-الملتحقين-بالمدارس",
      children: "الأطفال غير الملتحقين بالمدارس"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.4",
      children: [_jsx(_components.p, {
        children: "على مستوى العالم، هناك 272 مليون طفل وشاب خارج المدارس."
      }), _jsx(_components.p, {
        children: "الصراع هو السبب الرئيسي للركود. ولسوء الحظ، فإن الصراع يعني أيضًا تدهور مدى توفر البيانات وجودتها، على الرغم من أن بعض البلدان لا تزال تقدم تقديرات. وثمة حاجة أيضًا إلى مزيد من المعلومات المستدامة بمرور الوقت لتقييم الأثر الأخير لجائحة كوفيد-19 على الالتحاق بالدراسة بشكل صحيح."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "OOSRATE"
          })
        }), _jsx(ScrollySection, {
          id: "ECU,PRY",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "الإكوادور"
            }), " ", _jsx(Highlight, {
              children: "وباراغواي"
            }), " يظهران\nاتجاهات مختلفة جدًا لمدى التقدم. في التعليم الإعدادي والثانوي،\nانخفض معدل عدم الالتحاق بالمدارس في الإكوادور بشكل ملحوظ، في حين ارتفع في\nباراغواي."]
          })
        }), _jsx(ScrollySection, {
          id: "ERI,ETH",
          children: _jsxs(_components.p, {
            children: [_jsx(Highlight, {
              children: "إريتريا"
            }), " ", _jsx(Highlight, {
              children: "وأثيوبيا"
            }), " يظهران أيضًا\nمعدلات تقدم متباينة جدًا. إن الآثار اللاحقة للصراع الدائر في إريتريا\nكانت لها أبلغ الأثر على فرص الحصول على التعليم، في حين أعطت إثيوبيا الأولوية\nللتعليم في ميزانيتها، مما أدى إلى انخفاض سريع في عدد الأطفال المتسربين من التعليم\nخلال فترة وجيزة."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "وهناك سبب آخر لعدم إحراز تقدم في الحد من أعداد الأطفال غير الملتحقين بالمدارس وهو النمو السكاني."
    }), "\n", _jsxs(_components.p, {
      children: ["في منطقة أفريقيا جنوب الصحراء الكبرى، ", _jsx(HighlightByIndex, {
        index: "2",
        children: "تضاعف عدد السكان"
      }), " في سن الدراسة الابتدائية تقريبًا بين الأعوام 2000 إلى 2023. ونتيجة لذلك، ورغم أن ", _jsx(HighlightByIndex, {
        index: "0",
        children: "معدل الأطفال المتسربين من التعليم"
      }), " انخفض إلى النصف تقريبًا خلال هذه الفترة، فإن", _jsx(HighlightByIndex, {
        index: "1",
        children: "عدد الأطفال خارج الدراسة"
      }), " لم يتغير تقريبًا."]
    }), "\n", _jsx(Figure, {
      id: "OOSREL"
    }), "\n", _jsx(_components.h2, {
      id: "الإكمال",
      children: "الإكمال"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.2",
      children: [_jsxs(_components.p, {
        children: ["إن الهدف النهائي للهدف الرابع من أهداف التنمية المستدامة هو ", _jsx(_components.strong, {
          children: "إكمال"
        }), " التعليم الثانوي، وليس مجرد الالتحاق به. وهذا على الرغم من حقيقة مفادها أن التعليم في العديد من البلدان مجاني وإلزامي فقط حتى مرحلة التعليم الإعدادي على الأكثر."]
      }), _jsx(_components.p, {
        children: "ولكن العالم ليس حتى على المسار الصحيح لتحقيق إكمال التعليم الابتدائي الشامل بحلول الموعد النهائي، ناهيك عن إكمال التعليم الثانوي. ووفقا للاتجاهات الحالية، فإن حوالي ستة من كل عشرة شباب فقط سوف يكملون تعليمهم الثانوي في عام 2030."
      }), _jsxs(_components.p, {
        children: ["يبين المؤشر إلى أن الأطفال الذين قد يكملون مستويات التعليم حتى 3 أو 5 سنوات بعد سن التخرج الرسمية - ويمكن تعريف ذلك بأنه ", _jsx(Tooltip, {
          title: "الإكمال في الوقت المناسب",
          content: "الأطفال الذين يكملون مستويات التعليم حتى 3 أو 5 سنوات بعد الصف النهائي",
          children: "الإكمال في الوقت المناسب"
        }), ". لكن العديد من الأطفال يكملون تعليمهم بعد ذلك - ويمكن تعريف ذلك بأنه ", _jsx(Tooltip, {
          title: "الإكمال النهائي",
          content: "الأطفال الذين يكملون مستويات التعليم حتى 8 سنوات بعد الصف النهائي",
          children: "الإكمال النهائي"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["بالنظر إلى الرسم البياني أدناه، ففي موزمبيق، على سبيل المثال، هناك هوة تبلغ نحو 20 نقطة مئوية بين ", _jsx(HighlightByIndex, {
          index: "0",
          children: "الإكمال في الوقت المناسب"
        }), " (49%) والإكمال ", _jsx(HighlightByIndex, {
          index: "1",
          children: "في نهاية"
        }), " المطاف (66%) على المستوى الابتدائي."]
      }), _jsx(Figure, {
        id: "COMPLETION"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "خاتمة",
      children: "خاتمة"
    }), "\n", _jsx(_components.p, {
      children: "إن توقيت التحاق الأطفال بالمدارس، وفي أي سن، وما إذا كانوا يتخرجون أم لا، كلها قضايا سياسية بالغة الأهمية."
    }), "\n", _jsxs(_components.p, {
      children: ["تتناول المواضيع التالية على هذا الموقع مدى قربنا من تحقيق ", _jsx(PageLink, {
        name: "equity",
        children: "المساواة"
      }), " في التعليم، وما يتعلمه الطلاب ", _jsx(PageLink, {
        name: "learning",
        children: "ومدى "
      }), " جودة تعليمهم، ", _jsx(PageLink, {
        name: "quality",
        children: "والجهة"
      }), " التي", _jsx(PageLink, {
        name: "finance",
        children: "تموله"
      }), "."]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.education-estimates.org",
            children: "Visualizing Indicators of Education for the World (VIEW) (تصور مؤشرات التعليم في العالم"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://unesdoc.unesco.org/ark:/48223/pf0000382577",
            children: "New estimation confirms out-of-school population is growing in sub-Saharan Africa (تقديرات جديدة تؤكد أن عدد الأطفال غير الملتحقين بالمدارس آخذ في الازدياد في منطقة جنوب الصحراء الكبرى في أفريقيا)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://resourcecentre.savethechildren.net/library/education-against-odds-meeting-marginalised-childrens-demands-quality-education",
            children: "Education above the odds – Save the Children (التعليم فوق كل الصعاب – أنقذوا الأطفال)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Combining data on out-of-school children, Completion and learning to offer a more comprehensive view on SDG 4 (دمج البيانات حول الأطفال غير الملتحقين بالمدارس، والإكمال والتعلم لتقديم رؤية أكثر شمولًا حول الهدف الرابع من أهداف التنمية المستدامة)"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
